import { useShiftsStore } from 'frontcore/store/use-shifts-store/useShiftsStore'

const stateObject = {
  shifts: [],
}

const getters = {
  getShifts (state) {
    return state.shifts
  },
  getShiftById: (state) => (id) => {
    return state.shifts.find(shift => shift.id == id)
  },
}

const mutations = {
  __setShifts (state, shifts) {
    state.shifts = shifts
  },
}

const actions = {
  async fetchShifts ({ commit, state }) {
    const shiftsStore = useShiftsStore()
    const orderedShifts = await shiftsStore.fetch()
    const shifts = orderedShifts.map((shift) => {
      return {
        id: shift.id,
        name: shift.name,
        enabled: shift.enabled,
        order: shift.order,
        slots: shift.slots,
        begin_time: shift.beginTime,
        end_time: shift.endTime,
        enabled_days: {
          values: shift.enabledDays.values,
        },
        created: shift.created,
        device_update: shift.deviceUpdate,
        updated: shift.updated,
      }

    })
    commit('__setShifts', shifts)
    
    return state.shifts
  },
}

export default {
  state: stateObject,
  getters,
  mutations,
  actions,
}
